<template>
    <div class="mt-2">
        <b-form-select
            v-model="option"
            :options="filterOptions.legalForms"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'SelectLegalForm',

    mixins: [DataUpdater],

    data() {
        return {
            option: 0,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options,
        }),

        selectClass() {
            return this.option === 0
                ? 'bg-white'
                : 'bg-info text-primary font-weight-bold'
        },
    },

    created() {
        this.option = this.filters.legalForm
    },

    methods: {
        async setFilter() {
            await this.$store.dispatch(
                'reportingVM/setLegalFormFilter',
                this.option
            )
            this.$emit('legal-form-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },
    },
}
</script>

<style scoped></style>
